import React from 'react';
import { Text, Image, Modifier } from 'components';
import {
  HeartFilled,
  HeartOutlined,
  PushpinFilled,
  PushpinOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { encrypt } from 'utils/Crypto';
import { stringToMoneyFormat } from 'utils';

const MobileTable = ({
  data = [],
  isChecked = false,
  checkedList = [],
  onChecked = () => {},
  onCartNumber,
  onRemoveCart,
  onUpdateCart,
  navigate,
  screenSize,
}) => {
  if (!data.length) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '60px 20px',
          borderTop: '1px solid #dedede',
          borderBottom: '1px solid #dedede',
          marginTop: 20,
        }}
      >
        <Text size={16} color="var(--light-gray-color)">
          장바구니에 담긴 상품이 없습니다.
        </Text>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        marginTop: 20,
      }}
    >
      {data.map((item, idx) => {
        const isSelected = checkedList?.some(
          (d) => d.data?.cart_id === item.data?.cart_id
        );

        return (
          <div
            key={`mobile_cart_item_${idx}`}
            style={{
              border: '1px solid #ddd',
              borderRadius: 8,
              padding: 16,
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              background: isSelected ? '#fafafa' : '#fff',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 12,
                cursor: 'pointer',
              }}
              onClick={() =>
                navigate(
                  `/products/${encodeURIComponent(
                    encrypt(item.data.product_id)
                  )}`
                )
              }
            >
              <Image
                src={item.src}
                alt={item.product_name}
                style={{
                  width: 80,
                  aspectRatio: '4 / 5',
                  objectFit: 'cover',
                }}
              />
              <div style={{ flex: 1 }}>
                <Text size={14} weight={700}>
                  {item.brand}
                </Text>
                <Text size={16} style={{ webkitLineClamp: 'unset' }}>
                  {item.product_name}
                </Text>
                {item.option && (
                  <Text size={14} color="var(--light-gray-color)">
                    {item.option}
                  </Text>
                )}
                {item.regular_cycle && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 5,
                      flexWrap: 'wrap',
                      marginTop: 4,
                    }}
                  >
                    <Text size={14} color={'var(--light-gray-color)'}>
                      배송주기
                    </Text>
                    <Text size={14} color={'#D33444'}>
                      {item.regular_cycle.split('-')[0]}
                      {item.regular_cycle.split('-')[1] === 'W' ? '주' : '개월'}
                    </Text>
                    <Text size={14} color={'var(--light-gray-color)'}>
                      /
                    </Text>
                    <Text size={14} color={'var(--light-gray-color)'}>
                      배송횟수
                    </Text>
                    <Text size={14} color={'#D33444'}>
                      {item.max_regular_delivery_count === 0
                        ? '제한없음'
                        : `${item.max_regular_delivery_count}회`}
                    </Text>
                  </div>
                )}
              </div>
              {isChecked && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={(e) => onChecked(e, item)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginTop: 4, width: 16, height: 16 }}
                />
              )}
            </div>

            {item.isSoldOut === 'Y' ? (
              <Text color="#999999">품절</Text>
            ) : (
              <Modifier
                init={item.num}
                minNum={1}
                maxNum={99}
                readOnly
                unit={null}
                onIncrease={() => onCartNumber(item, item.num + 1)}
                onDecrease={() => onCartNumber(item, item.num - 1)}
                layoutStyle={{
                  height: 36,
                  width: screenSize >= 500 ? 150 : '100%',
                }}
              />
            )}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {/* 가격 표시 부분 수정 */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  gap: 4,
                }}
              >
                {item.discount_rate ? (
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 5 }}
                  >
                    <Text
                      size={14}
                      color="var(--light-gray-color)"
                      style={{ textDecoration: 'line-through' }}
                    >
                      {stringToMoneyFormat(item.price * item.num)} 원
                    </Text>
                    <Text size={16} weight={700}>
                      {stringToMoneyFormat(item.finalPrice * item.num)} 원
                    </Text>
                  </div>
                ) : (
                  <Text size={16} weight={700}>
                    {stringToMoneyFormat(item.finalPrice * item.num)} 원
                  </Text>
                )}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                <button
                  style={{ border: 'none', background: 'none', fontSize: 16 }}
                  onClick={() =>
                    item.isFixed
                      ? onUpdateCart('FIX_DELETE', item.data.cart_id)
                      : onUpdateCart('FIX_ADD', item.data.cart_id)
                  }
                >
                  {item.isFixed ? <PushpinFilled /> : <PushpinOutlined />}
                </button>
                <button
                  style={{ border: 'none', background: 'none', fontSize: 16 }}
                  onClick={() =>
                    item.isWish
                      ? onUpdateCart('WISH_DELETE', item.isWish)
                      : onUpdateCart('WISH_ADD', item.data.product_id)
                  }
                >
                  {item.isWish ? (
                    <HeartFilled style={{ color: '#D33444' }} />
                  ) : (
                    <HeartOutlined />
                  )}
                </button>
                <button
                  style={{ border: 'none', background: 'none', fontSize: 16 }}
                  onClick={() => onRemoveCart('single', item.data.cart_id)}
                >
                  <CloseOutlined />
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MobileTable;
